import React from 'react';
import { homeownerPost } from '../utils/homeownerApi';
import { HomeTransferSellerForm } from './HomeTransferScreens';

const ENDPOINT = '/.netlify/functions/home-transfer';

export default function HomeTransferSeller({ colors, reports }) {
  return (
    <div style={{
      background: (colors && colors.surface) || '#fff',
      border: `1px solid ${(colors && colors.border) || '#e6e6e6'}`,
      borderRadius: '0.75rem',
      padding: '1rem',
      marginBottom: '1rem',
    }}
    >
      <HomeTransferSellerForm
        colors={colors}
        reports={reports}
        onSubmit={async (fields) => {
          if (fields.cancel) {
            return homeownerPost(ENDPOINT, { action: 'cancel', transferId: fields.transferId });
          }
          return homeownerPost(ENDPOINT, {
            action: 'invite',
            accepted: true,
            closingDate: fields.closingDate,
            buyerEmail: fields.buyerEmail,
            reportId: fields.reportId,
          });
        }}
      />
    </div>
  );
}
